"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_imask_1 = require("react-imask");
const InputDateMask = ({ input, meta, ...rest }) => {
    const { label = '', placeholder = '', required, requiredIndicator = ' *', altclass = null, } = rest;
    /*
      https://www.npmjs.com/package/react-imask
      use ref to get access to internal "masked = ref.current.maskRef"
      const ref = React.useRef(null);
      const inputRef = React.useRef(null);
    */
    const labelClass = (0, classnames_1.default)({
        'form-label': altclass === 'coreUI',
    });
    const inputClass = (0, classnames_1.default)({
        'form-control': altclass === 'coreUI',
    });
    return ((0, jsx_runtime_1.jsxs)("fieldset", { "data-testid": `fieldset-${input.name}`, className: `input-date-mask-fieldset ${input.className ? input.className : undefined}`, children: [(0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsxs)("label", { "data-testid": `label-${input.name}`, htmlFor: input.name, className: `${altclass ? labelClass : ''}`, children: [label, required && ((0, jsx_runtime_1.jsx)("span", { className: "required-indicator", "aria-hidden": "true", children: requiredIndicator }))] }) }), (0, jsx_runtime_1.jsx)("div", { className: "input-wrapper", children: (0, jsx_runtime_1.jsx)(react_imask_1.IMaskInput, { ...input, ...rest, onAccept: input.onChange, type: "tel", placeholder: placeholder, name: input.name, pattern: 'm/d/Y', parse: (str) => {
                        const fullDate = str.split('/');
                        return new Date(Number(fullDate[2]), // Year
                        Number(fullDate[0]) - 1, // Month
                        Number(fullDate[1]) // Day
                        );
                    }, className: `input-date-mask ${altclass ? inputClass : ''}`, format: (date) => {
                        if (date) {
                            let day = date.getDate().toString();
                            let month = String(date.getMonth() + 1);
                            const year = date.getFullYear();
                            if (Number(day) < 10)
                                day = '0' + day;
                            if (Number(month) < 10)
                                month = '0' + month;
                            return [month, day, year].join('/');
                        }
                    }, "data-testid": `input-${input.name}` }) }), (meta.error || meta.submitError) && meta.touched && ((0, jsx_runtime_1.jsx)("span", { className: "error-message", children: meta.error || meta.submitError }))] }));
};
exports.default = InputDateMask;
